<template>
  <div class="products-view">
    <v-card>
      <v-card-title class="bg-blue text-white">
        Productos
      </v-card-title>

      <PanelProducts
        :page="page"
        :length="totalPages"
        :products="products"
        @onPageChange="onPageChange"
      />
    </v-card>
  </div>
</template>

<script>
import PanelProducts from '@/components/PanelProducts.vue'
import apisProducts from '@/apis/apisProducts'

export default {
  name: 'ProductsView',
  components: { PanelProducts },
  data() {
    return {
      products: [],
      page: 1,
      totalPages: 0
    }
  },
  created() {
    this.loadProducts()
  },
  methods: {
    loadProducts() {
      apisProducts.search('', '', '', this.page - 1)
        .then(response => {
          this.products = response.content
          this.totalPages = response.totalPages
        })
        .catch(error => {
          console.error('Error loading products:', error)
        })
    },
    onPageChange(newPage) {
      this.page = newPage
      this.loadProducts()
    }
  }
}
</script>

<style scoped>
.products-view {
  background-color: #121212;
  min-height: 100vh;
  padding-bottom: 30px;
}

.v-card {
  background-color: #1e1e1e;
  color: white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  border-radius: 10px;
}

.v-card-title.bg-blue {
  background-color: #102b65 !important;
  color: white;
  font-weight: bold;
}

.card-products {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  padding: 20px;
  background-color: #242424;
}

.ComponentProduct {
  height: 400px;
  width: 22%;
  min-width: 220px;
  padding: 10px;
}

@media screen and (max-width: 800px) {
  .card-products {
    gap: 10px;
    padding: 10px;
  }

  .ComponentProduct {
    width: 90%;
    height: auto;
  }
}
</style>
